import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import widgetLoader from 'dibs-widget-loader';
import FacebookIcon from 'dibs-vg/dist/react/facebook';

import {
    trackAccountConnectionClick,
    trackAccountConnectionSuccess,
    trackAccountDisconnectSuccess,
    trackSupportArticleCenterClick,
} from './trackingHelpers.es';
import ModifySocialNetworkConnectionMutation from '../SocialNetworks/ModifySocialNetworkConnectionMutation.es';
import FacebookConfirmationModal from './FacebookConfirmationModal';
import copy from './facebookAccountCopy.json';
import style from '../SocialNetworks/AccountSettings-style.scss';

class FacebookAccountSettings extends Component {
    constructor() {
        super();

        this.state = {
            isConfirmationModalOpen: false,
        };

        this.onAccountConnectionClick = this.onAccountConnectionClick.bind(this);
        this.onConfirmationModalClose = this.onConfirmationModalClose.bind(this);
    }

    connectFacebook(accessToken) {
        const { userId, relay } = this.props;

        ModifySocialNetworkConnectionMutation.commit(relay.environment, {
            userId,
            action: 'CONNECT',
            socialNetworkName: 'FACEBOOK',
            accessToken,
            onSuccess: () => {
                trackAccountConnectionSuccess();

                this.setState({
                    isConfirmationModalOpen: true,
                });
            },
        });
    }

    disconnectFacebook() {
        const { userId, userSocialNetwork, relay } = this.props;

        ModifySocialNetworkConnectionMutation.commit(relay.environment, {
            action: 'DISCONNECT',
            userId,
            userSocialNetworkId: userSocialNetwork && userSocialNetwork.serviceId,
            onSuccess: () => trackAccountDisconnectSuccess(),
        });
    }

    onAccountConnectionClick() {
        const { userSocialNetwork } = this.props;

        if (userSocialNetwork && userSocialNetwork.status === 'CONNECTED') {
            this.disconnectFacebook();
        } else {
            trackAccountConnectionClick();

            widgetLoader.load('facebook').then(FB => {
                FB.getLoginStatus(response => {
                    if (response.status === 'connected') {
                        this.connectFacebook(response.authResponse.accessToken);
                    } else {
                        FB.login(
                            loginResponse => {
                                this.connectFacebook(loginResponse.authResponse.accessToken);
                            },
                            { scope: 'email' }
                        );
                    }
                });
            });
        }
    }

    onConfirmationModalClose() {
        this.setState({
            isConfirmationModalOpen: false,
        });
    }

    render() {
        const { userSocialNetwork } = this.props;
        const isConnected = userSocialNetwork && userSocialNetwork.status === 'CONNECTED';

        return (
            <div className={style.row}>
                <div className={style.content}>
                    <FacebookIcon className={style.iconFacebook} />
                    <div>
                        <div className={style.title}>{copy.title}</div>
                        <div className={style.info}>
                            {isConnected && (
                                <div className={style.highlightedInfo}>
                                    {`https://www.facebook.com/${userSocialNetwork &&
                                        userSocialNetwork.socialId}`}
                                </div>
                            )}
                            {`${isConnected ? copy.changeAccountInfo : copy.connectInfo} `}
                            <a href={copy.infoCtaUrl} onClick={trackSupportArticleCenterClick}>
                                {copy.connectInfoCta}
                            </a>
                        </div>
                    </div>
                </div>
                <div className={style.ctaWrapper}>
                    <a
                        className={style.cta}
                        onClick={this.onAccountConnectionClick}
                        data-tn={`${isConnected ? 'disconnect' : 'connect'}-facebook`}
                    >
                        {isConnected ? copy.disconnectAccountCta : copy.connectAccountCta}
                    </a>
                </div>
                <FacebookConfirmationModal
                    isOpen={this.state.isConfirmationModalOpen}
                    onClose={this.onConfirmationModalClose}
                />
            </div>
        );
    }
}

FacebookAccountSettings.propTypes = {
    userId: PropTypes.string,
    userSocialNetwork: PropTypes.shape({
        serviceId: PropTypes.string,
        socialId: PropTypes.string,
        status: PropTypes.string,
        socialNetwork: PropTypes.shape({
            name: PropTypes.string,
        }),
    }),
    relay: PropTypes.object,
};

export default createFragmentContainer(FacebookAccountSettings, {
    userSocialNetwork: graphql`
        fragment FacebookAccountSettings_userSocialNetwork on UserSocialNetwork {
            ... on FacebookSocialNetwork {
                serviceId
                socialId
                status
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/global/components/Facebook/FacebookAccountSettings.jsx